import { useLayoutEffect, useRef, useState } from "react";

const FAKE_ROW_HEIGHT = 21;
const FOOTER_HEIGHT = 25;

const useViewportTableRows = (dataLength) => {
  const tableContainerRef = useRef(null);
  const tableBodyRef = useRef(null);
  const [fakeRowCount, setFakeRowCount] = useState(0);

  useLayoutEffect(() => {
    const tableContainer = tableContainerRef.current;
    if (!tableContainer) return undefined;

    let animationFrameId;

    const calculateFakeRows = () => {
      window.cancelAnimationFrame(animationFrameId);
      animationFrameId = window.requestAnimationFrame(() => {
        const tableTop = tableContainer.getBoundingClientRect().top;
        const headerHeight = tableContainer.querySelector("thead")?.offsetHeight ?? 0;
        const dataRows = [...(tableBodyRef.current?.querySelectorAll("tr:not(.fake-row-2)") ?? [])];
        const dataRowsHeight = dataRows.reduce((height, row) => height + row.offsetHeight, 0);
        const availableHeight =
          window.innerHeight - FOOTER_HEIGHT - tableTop - headerHeight - dataRowsHeight;
        const nextFakeRowCount = Math.max(0, Math.floor(availableHeight / FAKE_ROW_HEIGHT));

        setFakeRowCount((currentCount) =>
          currentCount === nextFakeRowCount ? currentCount : nextFakeRowCount
        );
      });
    };

    calculateFakeRows();
    window.addEventListener("resize", calculateFakeRows);

    const resizeObserver =
      typeof ResizeObserver === "undefined" ? null : new ResizeObserver(calculateFakeRows);
    resizeObserver?.observe(tableContainer);

    return () => {
      window.cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", calculateFakeRows);
      resizeObserver?.disconnect();
    };
  }, [dataLength]);

  return {
    fakeRowCount,
    tableBodyRef,
    tableContainerRef,
  };
};

export default useViewportTableRows;
